import InformationDialog from './InformationDialog';

export default { 
  name: "information", 
  component: InformationDialog, 
  fullScreen: false
};